module.exports = __webpack_public_path__ + "img/jingxiqx-icon.d2576d68.png";